import React from 'react'

export const ClientComponent = ({options}:{options:any[]}) => {
  return (
    <div>
      
    </div>
  )
}

